import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

import { PostMediaAsset_Asset } from '../../PostCard/PostMedia/PostMediaAsset'

/**
 * A content item as rendered by ContentItemCard. Only the channel-less
 * `DraftContent` body is selected — a ContentItem whose body is `PostContent`
 * is a channel-specific post shown by PostCard instead, and is filtered out
 * before rendering (see usePaginatedContentItems).
 *
 * DraftContent.assets is the same `Asset` interface as Post.assets, so the
 * media preview reuses PostMediaAsset_Asset unchanged.
 */
export const ContentItemCard_ContentItem = graphql(
  `
    fragment ContentItemCard_ContentItem on ContentItem {
      __typename
      id
      allowedActions
      targetDate
      title
      createdAt
      author {
        id
        name
        email
      }
      tags {
        id
      }
      body {
        __typename
        ... on DraftContent {
          id
          text
          aiAssisted
          assets {
            __typename
            ...PostMediaAsset_Asset
          }
        }
      }
    }
  `,
  [PostMediaAsset_Asset],
)

export type ContentItemCard_ContentItemData = ResultOf<
  typeof ContentItemCard_ContentItem
>
